import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CustomFormComponent} from '../../classes/custom-form-component';

let counter = 0;

@Component({
    selector: 'search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SearchInputComponent),
            multi: true,
        },
    ],
})
export class SearchInputComponent extends CustomFormComponent<string> implements OnInit, OnDestroy {
    static PLACEHOLDER = '';
    @Input() modern: boolean;
    @Input() loading: boolean;
    @Input() enableAutoFocus: boolean;
    @Input() clearOnDestroy = true;

    @Output() clear = new EventEmitter<void>();
    @Output() searchInput = new EventEmitter<string>();

    @ViewChild('searchInputEl', {static: true}) $inputEl: ElementRef<HTMLInputElement>;

    @HostBinding('class.modern') get isShown() {
        return this.modern;
    }

    get value() {
        return this.internalValue || '';
    }

    constructor($el: ElementRef, cd: ChangeDetectorRef) {
        super($el, cd);
    }

    ngOnInit() {
        this.id = this.id === undefined ? `searchInput-${++counter}` : this.id;
        this.placeholder = this.placeholder || SearchInputComponent.PLACEHOLDER;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.clearOnDestroy) {
            this.clearValue();
        }
    }

    getInput() {
        return this.$inputEl.nativeElement;
    }

    isInvalid() {
        return !this.getInput().validity.valid;
    }

    onChange() {
        let query = this.getInput().value.trim();
        this.invokeChangeCallback(query);
        this.searchInput.emit(query);
        if (!query) {
            this.clear.emit();
        }
    }

    clearValue() {
        this.getInput().value = '';
        this.onChange();
    }

    onClear(event: MouseEvent) {
        event.stopPropagation();
        this.clearValue();
    }
}
